<template >
  <div class="new-life">
    <my-scroll class="scroll">
      <div class="scroll-content">
        <header>GoLaos平台服务协议</header>
        <div class="letter"
             style="text-indent:2em">
          GoLaos平台依据以下条件和条款为您提供所享有的服务,请仔细阅读并遵守。
        </div>
        <h3>一、总则</h3>
        <div class="letter">
          1.本《GoLaos平台服务协议》（以下简称本协议）为您（即商户）与GoLaos（以下简称GoLaos）就GoLaos服务达成的协议。GoLaos在此特别提醒您认真阅读、充分理解本协议。商户应认真阅读、充分理解本协议中各条款，特别涉及免除或者限制GoLaos责任的免责条款，对商户的权利限制的条款，法律适用、争议解决方式的条款。
        </div>
        <div class="letter1 letter">
          2.请您审慎阅读并选择同意或不同意本协议，除非您接受本协议所有条款，否则您无权使用本协议项下相关服务。您的申请、使用、帐号获取和登录等行为表明您自愿接受本协议的全部内容并受其约束，不得以任何理由包括但不限于未能认真阅读本协议等作为纠纷抗辩理由。
        </div>
        <div class="letter1 letter">
          3.本协议可由GoLaos 随时更新，GoLaos会在网站、平台上公布最新版协议条款，更新后的协议条款在公布后二十四小时生效，如果您不接受修改后的条款，可在更新的条款公布后二十四小时内与GoLaos 平台客服联系，或者可立即停止使用GoLaos提供的服务，如果您没在更新后的条款公布后二十四小时内与GoLaos平台联系，或在更新后的条款公布后继续使用GoLaos提供的服务，将被视为您已接受了修改后的协议。
        </div>
        <h3>二、定义</h3>
        <div class="letter1 letter">
          1.GoLaos平台：是搭建、提供及维护网上商品售卖、餐饮服务信息发布的平台，用户和商户通过GoLaos平台对商品售卖及餐饮服务达成合意。
        </div>
        <div class="letter1 letter">
          2.用户：是指在GoLaos平台上发布商品求购、餐饮服务需求、创建任务事项信息的具有完全民事权利能力和行为能力的自然人。
        </div>
        <div class="letter1 letter">
          3.商户：即本协议中的“您”，是指通过GoLaos平台自主选择接受用户发布的商品售卖、餐饮服务任务信息、完成任务事项的依据老挝法律合法成立并有效存续的法人，或从事商品售卖、餐饮服务其他类型的商事主体。
        </div>
        <h3>三、商户的权利义务：</h3>
        <div class="letter letter1">
          1.商户应保证其为一家依据老挝法律合法成立并有效存续的法人， 或从事商品售卖、餐饮服务其他类型的商事主体，能够独立承担法律责任，并具有履行本合同所需一切权利及能力；同时商户应当提供盖章的资质证明复印件，如涉及特殊行业需要特定的资质或许可证等的，商户也应予以提供。前述资料包括但不限于商户营业执照、前置许可证件、外卖商品说明、页面信息文案所需资料、个人居住证明、身份证、护照、户口本（包括图片、商家介绍）等。商户保证提供的文件内容真实有效，不侵犯任何第三方的合法权益，由于信息虚假或不准确造成的一切后果与损失均由商户承担。商户的名称、地址和有效联系方式、许可证等信息发生变化的，商户应在一个工作日内书面或邮件通知GoLaos。由于商户未及时通知，给商户自身及GoLaos造成的一切损失均由商户承担。 </div>
        <div class="letter letter1">
          2.商户应向GoLaos提供商品的具体信息和详细说明。商户应保证自身具备提供本合同项下商品及履行本合同项下商户提供商品活动所有必要的资质批文、管理制度及合格人员，送达GoLaos用户的商品与页面描述一致且质量合格。
        </div>
        <div class="letter letter1">
          3.商户提供的外卖商品应符合国家法律、法规、规章的规定。如因商户商品存在质量或安全问题造成GoLaos用户投诉、索赔、经济损失等相关后果均由商户承担，如GoLaos基于前述情况向消费者先行赔付的，GoLaos有权向商户追偿，追偿方式包括但不限于在结算给商户的相关款项中直接扣除该赔付金额。
        </div>
        <div class="letter letter1">
          4.商户为GoLaos开辟绿色通道，具体事宜如：商户在接收到GoLaos用户的订单后，应优先处理GoLaos用户的订单，并由商户负责将订单中所述的商品及时送达至GoLaos用户。送达过程采取合理包装及方式，保证送达GoLaos用户商品安全、及时、无污染。
        </div>
        <div class="letter letter1">
          5.商户不应就在线标注价格之外向GoLaos用户收取任何线下费用。如GoLaos用户所订购商品售罄，经商户与GoLaos用户沟通后，商户可就替代商品线下向用户收取差价部分。
        </div>
        <div class="letter letter1">
          6.如GoLaos用户要求开具发票，由商户负责全额提供，GoLaos系统通知商户用户下单信息后，如商户因商品售罄等原因，不能提供的，商户应立即电话通知下单信息的用户和GoLaos，并做好合理的安抚和处理措施，如因此造成GoLaos用户投诉、经济损失等相关后果均由商户承担。
        </div>
        <div class="letter letter1">
          7.商户应严格按照双方协商签订的活动方案为GoLaos用户提供相应的优惠价格或赠品，不允许出现故意拒不提供的行为，否则由此产生的用户投诉和损失均由商户承担。
        </div>
        <div class="letter letter1">
          8.商户承诺自己在使用GoLaos时不会出现以下违规行为，如因出现以下违规行为导致任何法律后果的发生，由商户自行承担所有法律责任：
        </div>
        <div class="letter letter1">
          9.违反国家法律、法规要求以及各种社会公共利益或公共道德的行为；
        </div>
        <div class="letter letter1">
          10.违反GoLaos相关规定的行为（包括但不限于制造虚假订单、利用系统漏洞获取利润、违规套现、对用户消费欺诈、无故取消订单、无故拒绝配送等）；
        </div>
        <div class="letter letter1">
          11.其他损害GoLaos平台、用户和其他商户利益的行为。
        </div>
        <div class="letter letter1">
          12.商户可以通过用户名和密码登陆GoLaos商家后台，商户应对密码安全及通知实施的行为负责，商户不得以任何形式将用户名和密码转让或泄露给第三方。
        </div>
        <div class="letter letter1">
          13.商户提供的银行账户信息须准确，如发生变更应立即通知GoLaos，否则，由此造成的款项延误等后果均由商户承担。
        </div>
        <div class="letter letter1">
          14.商户保证经营场所内实际销售价格不得低于商品在线标注价格，且不得唆使或引导GoLaos用户放弃在GoLaos服务，改为其他形式的商户和GoLaos用户直接交易，否则GoLaos有权立即终止合作并要求商户按照协议第六条承担违约责任。
        </div>
        <div class="letter letter1">
          15.商户同意GoLaos可能会与第三方合作向商户提供相关的网络服务，在此情况下，如该第三方同意承担与GoLaos同等的保护用户隐私的责任，则GoLaos有权将用户的信息资料等提供给该第三方。另外，在不透露单个商户隐私资料的前提下，GoLaos有权对整个商户数据库进行分析并对商户数据库进行商业上的利用。
        </div>
        <div class="letter letter1">
          16.商户同意GoLaos拥有通过信息推送、平台公示、短信、电话、邮件等形式向您通知告知信息的权利，商户允许平台向其发送商业性电子信息。
        </div>
        <h3>四、GoLaos权利与义务</h3>
        <div class="letter1 letter">
          1.GoLaos为商户提供本协议项下约定的GoLaos平台的网络展示，并按照GoLaos平台约定向商户收取服务费。
        </div>
        <div class="letter1 letter">
          2.GoLaos为商户在消费群体中做相关宣传介绍并进行相关推荐，以提升商户的知名度。商户同意授权GoLaos使用其品牌、LOGO、名称、商标等知识产权。
        </div>
        <div class="letter letter1">
          3.GoLaos有权对商户拟在GoLaos发布的内容、信息进行审核，必要时可删改。GoLaos有权对不符合法律法规、政策规定的内容或任何侵犯第三方合法权益的内容予以删改或拒绝发布，但甲乙双方确认，GoLaos的前述审核、删改不为GoLaos设置任何义务，也不免除商户根据本协议应承担的责任。
        </div>
        <div class="letter1 letter">
          4.如任何第三方向GoLaos投诉，GoLaos经核实后，有权要求商户配合解决该投诉。如出现不符合法律法规、政策规定或侵犯第三方合法权益的内容的，GoLaos有权在不通知商户的情况下做下线处理。
        </div>
        <div class="letter1 letter">
          5.商户店铺内所售品类如有违反GoLaos平台经营范围的相关规定或有向消费者私自售卖违禁品的行为，GoLaos平台有权按照相关规定对商户进行处罚，并举报至相关行政主管部门。
        </div>
        <div class="letter1 letter">
          6.如活动方案中涉及GoLaos承担相应成本费用的内容，则GoLaos应按合同中双方约定的结算方式，定期由GoLaos系统自动结算的方式为商户支付活动期间产生的成本费用。
        </div>
        <div class="letter1 letter">
          7.GoLaos用户退单情形，GoLaos应在收到退订申请后告知商户取消对应商品售卖项目。商户应根据GoLaos通知做相应的调整。
        </div>
        <div class="letter1 letter">
          8.如商户违反本协议第三条项下约定的义务，GoLaos有权随时停止提供服务，并操作商户商品信息下线。
        </div>
        <div class="letter1 letter">
          9.本协议项下服务终止时，GoLaos有权删除GoLaos上的商户已发布的商品信息，且有权拒绝向商户提供相关信息；GoLaos有权保存商户资质信息、商品信息、交易记录等相关资料。
        </div>
        <h3>
          五、知识产权
        </h3>
        <div class="letter letter1">
          1.双方的品牌归各自所有。双方均不可在对方未经授权的情况下使用对方名称、Logo以及涉及相关内容的销售、促销宣传材料及广告、报纸、杂志、宣传单等，如因此产生的所有不良后果及损失违约方全部承担。本协议第4.2条有约定的除外。
        </div>
        <h3>六、食品安全保障</h3>
        <div class="letter letter1">
          1.商户提供的资质应符合国家相关法律的规定，并且符合发布相关商品的要求，当平台要求提供时可以在24小时内提供资质完成备案，如果因无法提供相关资质导致平台的损失需要由商户承担。
        </div>
        <div class="letter letter1">
          2.商户提供的商品应符合国家法律、法规、规章的规定。如因商户商品存在质量或安全问题造成GoLaos用户投诉、索赔、经济损失等相关后果均由商户承担，如GoLaos基于前述情况向消费者先行赔付的，GoLaos有权向商户追偿，追偿方式包括但不限于在结算给商户的相关款项中直接扣除该赔付金额。
        </div>
        <h3>七、违约责任</h3>
        <div class="letter letter1">
          1.任何一方违反本协议所规定的义务导致另一方受到包括但不限于投诉、举报、诉讼或处罚、赔偿等损失，违约方在收到守约方要求纠正其违约行为的书面通知之日，应立即停止其违约的行为，并在10日内赔偿守约方因此受到的所有损失。
        </div>
        <div class="letter letter1">
          2.本协议任何一方均应对其获得的对方的业务、经营、财务状况和其他保密资料予以严格保密，不得以任何形式向任何第三方披露。如因任何一方未能履行保密义务而给其他方造成任何损失的，应承担赔偿责任。
        </div>
        <h3>八、免责条款</h3>
        <div class="letter letter1">
          1.不论在何种情况下，GoLaos均不对由于互联网正常的设备维护，互联网络连接故障，电脑、通讯或其他系统的故障，电力故障，黑客攻击、病毒侵袭、罢工，劳动争议，暴乱，起义，骚乱，生产力或生产资料不足，火灾，洪水，风暴，爆炸，战争，政府行为，司法行政机关的命令或第三方的不作为而造成的不能服务或延迟服务承担责任。
        </div>
        <div class="letter letter1">
          2.商户同意自行承担使用网络服务的风险，GoLaos不作任何类型的担保，包括但不限于：不担保服务一定能满足商户的要求；不担保服务不会受中断，对服务的及时性，安全性，出错发生不担保；对在GoLaos上以及第三方合作得到的任何服务或交易进程，不作担保；对GoLaos服务所涉及的技术及信息的有效性、准确性、正确性、可靠性、稳定性、完整性和及时性不作出任何承诺和保证；不担保GoLaos服务的适用性没有错误或疏漏。
        </div>
        <h3>九、争议解决</h3>
        <div class="letter letter1">
          1.本协议的订立、执行和解释及争议的解决均应适用老挝人民民主共和国法律
        </div>
        <div class="letter letter1">
          2.就本协议内容或执行发生任何争议，应友好协商解决，协商不成时，按老挝法律规定的程序解决。
        </div>
      </div>
    </my-scroll>
  </div>
</template>

<script>

import MyScroll from '../../components/MyScroll'
export default {
  name: 'newLifeZh',
  components: {
    MyScroll
  },
  setup () {
    // const { ctx } = getCurrentInstance()
    // console.log(ctx.$root.$route.query.lang)
    return {
      txt1: ''
    }
  }
}
</script>

<style scoped lang="scss">
@mixin flex-box-center {
  display: flex;
  justify-content: center;
  align-items: center;
}
.new-life {
  width: 100%;
  .scroll {
    width: 100%;
    height: 100%;
    padding: 0px 16px;
    position: absolute;
    touch-action: none;
    overflow: hidden;
    -webkit-overflow-scrolling: touch;
    &::-webkit-scrollbar {
      width: 0px;
    }
    header {
      width: 100%;
      margin-top: 25px;
      margin-bottom: 35px;
      height: 28px;
      padding: 0px 16px;
      overflow: hidden;
      opacity: 1;
      font-size: 20px;
      font-weight: bold;
      color: #333333;
      @include flex-box-center;
    }
    .scroll-content {
      position: absolute;
      top: 0px;
      padding: 0px 16px;
      left: 0px;
      h3 {
        padding: 13px 0px 0px;
        margin-bottom: 12px;
        // height: 25px;
        opacity: 1;
        font-size: 15px;
        font-weight: bold;
        text-align: left;
        color: #333333;
        // line-height: 40px;
      }
      span {
        // font-weight: 600;
      }
      .letter {
        text-align: left;
        opacity: 1;
        font-size: 15px;
        font-weight: 400;
        line-height: 25px;
        white-space: normal;
        color: #333333;
      }
      .letter1 {
        margin-top: 12px;
      }
    }
  }
}
</style>
